import "reflect-metadata";
import fontsCSS from "./UI/fonts/fonts.css?inline";
import dssCSS from "@salut/design-system-salut/css/main.css?inline";

// Inject CSS automatically
if (typeof document !== "undefined") {
  const style = document.createElement("style");
  style.textContent = fontsCSS + "\n" + dssCSS;
  document.head.appendChild(style);
}
export * from "./bootstrapper";
export * from "./disposer";
export * from "./api/region-manager/regions";
export * from "./handle-plugins";
export * from "./api/api";
export * from "./api/broker/primaria-broker";
export type { PrimariaContextManager, EcapContext } from "./api/context-manager/context-manager";
export * from "./UI/index";
export { PrimariaNavItem } from "./UI/shared-components/primaria-nav-item/primaria-nav-item";
export { QuickActionItem } from "./UI/shared-components/quick-action-item/quick-action-item";
export { PrimariaRegion } from "./UI/shared-components/primaria-region";
export {
  EcapEventManager,
  createEcapEventManager,
} from "./api/ecap-event-manager/ecap-event-manager";
export type { IEcapEvent } from "./api/ecap-event-manager/typings";
export * from "@uxland/harmonix-adapters";
export * from "./api/interaction-service";
export { ExitShell } from "./features/exit/request";
export type { ExitShellPayload } from "./features/exit/request";
export type { IUserInfo } from "./features/get-user-info/model";
export type {
  IActivityHistoryItem,
  IHistoryDataImporterContext,
  IHistoryDataImporterRules,
} from "../../../plugins/activity-history/src/activity-history-item/domain/model";
export type { InjectAsyncHistoryItemsPayload } from "../../../plugins/activity-history/src/activity-history-item/add/add-async-history-items/request";
export type { AddHistoryItemPayload } from "../../../plugins/activity-history/src/activity-history-item/add/add-history-item/request";
export type { AddHistoryItemsPayload } from "../../../plugins/activity-history/src/activity-history-item/add/add-history-items/request";
export type { ActivityHistoryFilterType } from "../../../plugins/activity-history/src/activity-history-item/filter/model";
export type {
  IActivityHistoryCustomFilterGroup,
  IActivityHistoryCustomFilter,
} from "../../../plugins/activity-history/src/activity-history-item/filter/model";
